import { APPROVED, REJECTED, GENERATED, EDITED, PENDING, UNCHANGED } from "./status";

export const statusColor = (status, hover) => {
    const colors = {
        rejected: ["#fab090", "#f7a683"],
        approved: ["#d9efe0", "#c5e7cf"],
        pending:  ["#d9eaf8", "#c6e1f5"]
    };
    if (status === 'rejected') {
        return hover ? colors.rejected[1] : colors.rejected[0];
    } else if (status === 'approved') {
        return hover ? colors.approved[1] : colors.approved[0];
    } else {
        return hover ? colors.pending[1] : colors.pending[0];
    }
};

export const bsciCalc = (bsciNum) => {
    let bsciStatus = '-';
    if (!bsciNum) {
        return bsciStatus;
    }
    const bsci = parseFloat(bsciNum);
    if (bsci >= 0.75) {
        bsciStatus = `bsciScoreGreen`;
    } else if (bsci >= 0.60 && bsci <= 0.74) {
        bsciStatus = `bsciScoreAmber`;
    } else if (bsci < 0.60) {
        bsciStatus = `bsciScoreRed`;
    }
    return [bsciStatus, bsciNum];
}
/*
export function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

export function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

export function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}
*/

export const statusOrder = {
    approved: 1,
    generated: 2,
    edited: 3,
    unchanged: 4,
    rejected: 5,
};

function descendingComparator(a, b, orderBy, isSub) {
  if (orderBy === 'content_status') {
    const orderA = (isSub ? statusOrder[a[isSub][orderBy]] : statusOrder[a[orderBy]]) || Number.MAX_SAFE_INTEGER; // Default to max integer if status is unknown
    const orderB = (isSub ? statusOrder[b[isSub][orderBy]] : statusOrder[b[orderBy]]) || Number.MAX_SAFE_INTEGER;

    if (orderB < orderA) {
      return -1;
    }
    if (orderB > orderA) {
      return 1;
    }
    return 0;

  } else if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}


export function getComparator(order, orderBy, isSub) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy, isSub)
    : (a, b) => -descendingComparator(a, b, orderBy, isSub);
}

const stabilizedThis = (data, comparator) => {
  const list = data.map((el, index) => [el, index]);
  list.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return list.map((el) => el[0]);
}

export function stableSort(array, comparator, isChild) {

  // const comparator = getComparator(order, orderBy);
  if (isChild) {
    // const comparator = getComparator(order, orderBy);
    // const sortedFaqs = stableSort(allFaqs, comparator);
    // let index = 0;
    // return array.map(item => {
    //   const sortedFaqsForItem = item[isChild].map(() => sortedFaqs[index++]);
    //   return { ...item, [isChild]: sortedFaqsForItem };
    // });
    return array.map(item => {
      return {
      ...item,
        [isChild]: stabilizedThis(item[isChild], comparator)
      };
    });
  } else {
    // const stabilizedThis = array.map((el, index) => [el, index]);
    // stabilizedThis.sort((a, b) => {
    //   const order = comparator(a[0], b[0]);
    //   if (order !== 0) {
    //     return order;
    //   }
    //   return a[1] - b[1];
    // });
    return stabilizedThis(array, comparator);
  }
}

export function scoreInsight(score) {
    return (score && Math.floor(score) !== 0) ? (Math.floor(score) + '%') : '-';
}

export function areArraysEqual(array1, array2) {
  if (array1.length !== array2.length) {
    return false; // Different lengths
  }

  const sortedArray1 = [...array1].sort();
  const sortedArray2 = [...array2].sort();

  for (let i = 0; i < sortedArray1.length; i++) {
    if (sortedArray1[i] !== sortedArray2[i]) {
      return false; // Different values
    }
  }

  return true; // Arrays are equal
}

export function statusCounter(data, child, filterChild) {
    let count = {accepted: 0, rejected: 0, pending: 0};
    // let count1 = 0, count2 = 0, count3 = 0;
    if (Array.isArray(data) && data.length) {
      if (filterChild) {
        const statusCounts = {};
        data.forEach(item => {
          item[child].forEach(({ content_status: status }) => {
            // Normalize status to handle potential typos
            const normalizedStatus = status.toLowerCase();
            // Initialize count if not already present
            if (!statusCounts[normalizedStatus]) {
              statusCounts[normalizedStatus] = 0;
            }
            // Increment the count for the current status
            statusCounts[normalizedStatus]++;
          });
        });
        return {accepted: statusCounts.approved, rejected: statusCounts.rejected, pending: ((statusCounts.edited || null) + statusCounts.generated)};
      }
      data.forEach(item => {
        if (item?.content_status === APPROVED || item[child]?.content_status === APPROVED) {
          count = {...count, accepted: count.accepted + 1}
        }
        if (item?.content_status === REJECTED || item[child]?.content_status === REJECTED) {
          count = {...count, rejected: count.rejected + 1}
        }
        if ([GENERATED, EDITED, PENDING, UNCHANGED].includes(item?.content_status) || [GENERATED, EDITED, PENDING].includes(item[child]?.content_status)) {
          count = {...count, pending: count.pending + 1}
        }
      });
    }
    return count;
}

